import {isFeatureEnabled} from '@github-ui/feature-flags'
import {Outlet} from '@github-ui/react-router'
import {PageLayout} from '@primer/react'
import {clsx} from 'clsx'
import type {CSSProperties, ReactElement} from 'react'

import styles from './SharedLayout.module.css'

const contentStyle: CSSProperties = {maxWidth: '1400px'}

interface SharedLayoutProps {
  header: ReactElement
  sidebar: ReactElement
}

export function SharedLayout({sidebar, header}: SharedLayoutProps) {
  const useFooterRedesign = isFeatureEnabled('primer_footer_redesign')

  return (
    <PageLayout
      containerWidth="full"
      columnGap="none"
      padding="none"
      className={clsx(useFooterRedesign && styles.FooterRedesignOffset)}
    >
      <PageLayout.Pane
        divider="line"
        hidden={{narrow: true, regular: false, wide: false}}
        padding="condensed"
        position="start"
        className="min-height-full"
      >
        <aside>{sidebar}</aside>
      </PageLayout.Pane>

      <PageLayout.Content as="div" padding="condensed" className="px-2 mx-auto" style={contentStyle}>
        {header}
        <Outlet />
      </PageLayout.Content>
    </PageLayout>
  )
}
